module.exports = [
  'chooseImage',
  'previewImage',
  'uploadImage',
  'downloadImage',
  'getNetworkType',
  'getLocation',
  'scanQRCode',
  'getUA',
  'isApiSupported',
  'use',
  'openWebview',
  'share'
]